export default __webpack_public_path__ + "static/media/google_chrome.3e91b77c.svg";